import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OverallUserDashboardComponent } from './f1-gtm/f1-gtm-components/overall-user-dashboard/overall-user-dashboard.component';
const routes: Routes = [
  {
    path: "",
    loadChildren: ()=> import('./f1-gtm/f1-gtm-routing.module').then(m=>m.F1GtmRoutingModule)
  },
  { path: 'f1-gtm', loadChildren: () => import('./f1-gtm/f1-gtm.module').then(m => m.F1GtmModule) },
  {
    path: '**',
    loadChildren: () =>
    import('./../../../apna-lib/src/lib/components/page404/page404.module').then((m) => m.Page404Module),
  },
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: 'dashboard', component: OverallUserDashboardComponent },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledBlocking',
      scrollPositionRestoration: 'enabled',
      anchorScrolling: "enabled",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
